import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgChartsModule } from 'ng2-charts';
import { ChartistModule } from 'ng-chartist';
import { Routes, RouterModule } from '@angular/router';
import { ProjectComponent } from './Dashboard-component/project/project.component';
import { PageAnalyzerComponent } from './Dashboard-component/page-analyzer/pa.component';
import { ActivityComponent } from './Dashboard-component/activity-timeline/activity.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { UploadModule } from '@progress/kendo-angular-upload';
import { GridModule } from '@progress/kendo-angular-grid/';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns/';
import { HttpClientModule } from '@angular/common/http';
import { IntlModule } from '@progress/kendo-angular-intl';
import { DashboardService } from './service/dashboardservice';
import { AuthInterceptorService } from '../core/auth-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import {SharedModule} from '../shared/shared.module';
import { StarterComponent } from './starter.component';
import { DetailsComponent } from './details';
import { JwPaginationModule } from 'jw-angular-pagination';
import { MoneySuffixPipe } from './pipe/money-suffix.pipe'
import { FilterPipe } from './pipe/filter.pipe'
import { MultiRaterService } from '../multirater/service/multirater-service';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DashBoardFilterSearchComponent } from './DashBoard-modal/dashboardfiltersearch.component';
import { MessageBox } from '../commoncomponent/MessageBox/MessageBox';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DownloadFileModalComponent } from './modal/downloadFile.component';
import { ViewAttachmentModalComponent } from './modal/viewAttachment.component';

import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { AuthRouteGuard } from '../core/auth-route-guard';
import { FullComponent } from '../layouts/full/full.component';

import { DragScrollModule } from 'ngx-drag-scroll';

const routes: Routes = [
      // {
      //   path: '',
      //   redirectTo: 'dashboard',
      //   pathMatch: 'full'
      // },
      {
          path: 'dashboard',
          component: FullComponent,
          canActivate: [
            AuthRouteGuard,
          ],
          data: {
              title: 'Dashboard',
              urls: [
                  { title: 'Dashboard', url: '' }
              ]
          },
          children: [
            { path: '', component: StarterComponent},
            {
              path: 'details',
              data: {
                title: 'Dashboard',
                urls: [
                    { title: 'Dashboard', url: '/details' }
                ]
              },
              component: DetailsComponent
            }
          ]
      },
      {
          path: 'details',
          data: {
            title: 'Dashboard',
            urls: [
                { title: 'Dashboard', url: '/details' }
            ]
          },
          component: DetailsComponent
      }
   
];

@NgModule({
  imports: [
    FormsModule, 
    CommonModule,    
    ChartistModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes), 
    PerfectScrollbarModule, 
    GridModule,
    LayoutModule,
    DropDownsModule,
    HttpClientModule,
    IntlModule,
    NgbModule,
    DialogsModule,
    JwPaginationModule,
    NgChartsModule,
    SharedModule,
    UploadModule,
    NgxPaginationModule,
    DateInputsModule,
    NzMessageModule,
    NzNotificationModule,
    NzSelectModule,
    NzGridModule,
    DragScrollModule
  ],
  declarations: [
    StarterComponent,
    DetailsComponent,
    ProjectComponent,
    PageAnalyzerComponent,
    ActivityComponent,
    MoneySuffixPipe,
    FilterPipe,
    DashBoardFilterSearchComponent,
    DownloadFileModalComponent,
    ViewAttachmentModalComponent
  ],
  entryComponents: [DashBoardFilterSearchComponent,DownloadFileModalComponent,ViewAttachmentModalComponent],
  providers: [
    DashboardService,
    DatePipe,
    DecimalPipe,
    FilterPipe,
    MessageBox,
    MultiRaterService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }
  ],
  exports: [
    ViewAttachmentModalComponent
  ]
})

export class StarterModule {}

